(function() {
  'use strict';

  const SocialProof = {
    container: null,
    toast: null,
    timer: null,
    index: 0,
    dismissed: false,
    paused: false,

    products: [
      { handle: 'smooth-operator', name: 'Smooth Operator', img: null },
      { handle: 'overtime-lube', name: 'Overtime', img: null },
      { handle: 'backstage-pass', name: 'Backstage Pass', img: null },
      { handle: 'just-in-case-8-pack', name: 'Just In Case (8er)', img: null },
      { handle: 'the-3some-bundle', name: '3some Bundle', img: null },
      { handle: 'wettr-essentials', name: 'wettr Essentials', img: null },
      { handle: 'backstage-essentials', name: 'Backstage Essentials', img: null },
      { handle: 'the-all-nighter', name: 'The All-Nighter', img: null },
      { handle: 'mix-match-lubes', name: 'Mix & Match Lubes', img: null },
      { handle: 'double-trouble', name: 'Double Trouble', img: null },
    ],

    // Weighted cities: ~70% Germany, ~30% EU
    cities: {
      de: [
        'Berlin', 'M\u00fcnchen', 'Hamburg', 'K\u00f6ln', 'Frankfurt',
        'D\u00fcsseldorf', 'Stuttgart', 'Leipzig', 'Hannover', 'N\u00fcrnberg',
        'Dresden', 'Mannheim', 'Essen', 'Dortmund', 'Bremen',
      ],
      eu: [
        'Wien', 'Z\u00fcrich', 'Amsterdam', 'Br\u00fcssel', 'Paris',
        'Mailand', 'Barcelona', 'Kopenhagen', 'Stockholm', 'Prag',
      ],
    },

    names: [
      'Max', 'Leon', 'Lukas', 'Jonas', 'Finn', 'Elias', 'Paul', 'Noah',
      'Ben', 'Luis', 'Felix', 'Luca', 'Tim', 'David', 'Moritz', 'Tom',
      'Nico', 'Julian', 'Philipp', 'Jan', 'Daniel', 'Kevin', 'Marco',
      'Tobias', 'Fabian', 'Alex', 'Chris', 'Patrick', 'Dennis', 'Stefan',
      'Erik', 'Sven', 'Lars', 'Florian', 'Marcel', 'Sebastian', 'Oliver',
    ],

    lastInitials: 'ABCDEFGHKLMNPRSTW',

    actions: {
      de: [
        { text: 'hat gerade <strong>{product}</strong> gekauft', icon: '\ud83d\udce6' },
        { text: 'hat <strong>{product}</strong> zum Warenkorb hinzugef\u00fcgt', icon: '\ud83d\uded2' },
        { text: 'hat sein Paket mit <strong>{product}</strong> erhalten', icon: '\u2705' },
        { text: 'hat gerade <strong>{product}</strong> bestellt', icon: '\ud83c\udf89' },
        { text: 'hat sich f\u00fcr <strong>{product}</strong> entschieden', icon: '\ud83d\udc4c' },
      ],
      en: [
        { text: 'just purchased <strong>{product}</strong>', icon: '\ud83d\udce6' },
        { text: 'added <strong>{product}</strong> to cart', icon: '\ud83d\uded2' },
        { text: 'received their <strong>{product}</strong> package', icon: '\u2705' },
        { text: 'just ordered <strong>{product}</strong>', icon: '\ud83c\udf89' },
        { text: 'chose <strong>{product}</strong>', icon: '\ud83d\udc4c' },
      ],
    },

    timeAgo: {
      de: ['gerade eben', 'vor 1 Min.', 'vor 2 Min.', 'vor 3 Min.', 'vor 5 Min.'],
      en: ['just now', '1 min ago', '2 min ago', '3 min ago', '5 min ago'],
    },

    verified: {
      de: 'Verifizierter Kauf',
      en: 'Verified purchase',
    },

    getLang() {
      const html = document.documentElement;
      const lang = html.getAttribute('lang') || 'en';
      return lang.startsWith('de') ? 'de' : 'en';
    },

    rand(arr) {
      return arr[Math.floor(Math.random() * arr.length)];
    },

    getCity() {
      return Math.random() < 0.7
        ? this.rand(this.cities.de)
        : this.rand(this.cities.eu);
    },

    getName() {
      const first = this.rand(this.names);
      const last = this.lastInitials[Math.floor(Math.random() * this.lastInitials.length)];
      return first + ' ' + last + '.';
    },

    generateNotification() {
      const lang = this.getLang();
      const product = this.rand(this.products);
      const action = this.rand(this.actions[lang]);
      const name = this.getName();
      const city = this.getCity();
      const time = this.rand(this.timeAgo[lang]);

      return {
        name,
        city,
        text: action.text.replace('{product}', product.name),
        icon: action.icon,
        time,
        product,
        lang,
      };
    },

    async loadProductImage(handle) {
      // Try to get product image from Shopify
      const cached = this.products.find(p => p.handle === handle);
      if (cached && cached.img) return cached.img;

      try {
        const resp = await fetch('/products/' + handle + '.js');
        if (resp.ok) {
          const data = await resp.json();
          if (data.featured_image) {
            const img = data.featured_image.replace(/(\.\w+)$/, '_100x100$1');
            if (cached) cached.img = img;
            return img;
          }
        }
      } catch (e) {}
      return null;
    },

    async show() {
      if (this.dismissed || this.paused) return;

      const data = this.generateNotification();
      const imgUrl = await this.loadProductImage(data.product.handle);

      const imgHtml = imgUrl
        ? '<img class="social-proof__image" src="' + imgUrl + '" alt="' + data.product.name + '" loading="lazy">'
        : '<div class="social-proof__image" style="display:flex;align-items:center;justify-content:center;font-size:24px;background:#f0f0f0;">' + data.icon + '</div>';

      this.toast.innerHTML =
        '<button class="social-proof__close" aria-label="Close">&times;</button>' +
        imgHtml +
        '<div class="social-proof__content">' +
          '<p class="social-proof__text">' +
            '<span class="social-proof__name">' + data.name + '</span> ' +
            (data.lang === 'de' ? 'aus' : 'from') + ' ' + data.city +
            ' ' + data.text +
          '</p>' +
          '<div class="social-proof__meta">' +
            '<span class="social-proof__dot"></span>' +
            '<span>' + data.time + '</span>' +
            '<span>\u00b7</span>' +
            '<span class="social-proof__verified">' +
              '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>' +
              (data.lang === 'de' ? this.verified.de : this.verified.en) +
            '</span>' +
          '</div>' +
        '</div>';

      // Bind close
      this.toast.querySelector('.social-proof__close').addEventListener('click', function(e) {
        e.stopPropagation();
        SocialProof.dismiss();
      });

      // Animate in
      this.toast.classList.remove('is-hiding');
      void this.toast.offsetWidth; // force reflow
      this.toast.classList.add('is-visible');

      // Auto-hide after 5s
      setTimeout(function() {
        SocialProof.hide();
      }, 5000);
    },

    hide() {
      this.toast.classList.remove('is-visible');
      this.toast.classList.add('is-hiding');
    },

    dismiss() {
      this.hide();
      this.dismissed = true;
      clearTimeout(this.timer);
      try {
        sessionStorage.setItem('social-proof-dismissed', '1');
      } catch(e) {}
    },

    init() {
      // Don't show in editor
      if (window.Shopify && window.Shopify.designMode) return;
      // Don't show if dismissed this session
      try {
        if (sessionStorage.getItem('social-proof-dismissed') === '1') return;
      } catch(e) {}

      this.container = document.querySelector('.social-proof');
      if (!this.container) return;

      this.toast = this.container.querySelector('.social-proof__toast');
      if (!this.toast) return;

      // wettr: product list comes from Liquid (only available products); never fall back to the hardcoded list
      try {
        var spData = document.getElementById('social-proof-products');
        this.products = spData ? JSON.parse(spData.textContent) : [];
      } catch (e) { this.products = []; }
      if (!this.products.length) return;

      // Pause on hover
      this.toast.addEventListener('mouseenter', function() { SocialProof.paused = true; });
      this.toast.addEventListener('mouseleave', function() { SocialProof.paused = false; });

      // Pre-load first 3 product images
      var self = this;
      var preload = this.products.slice(0, 3);
      preload.forEach(function(p) { self.loadProductImage(p.handle); });

      // wettr 2026-11-04: slower, irregular rhythm (first after 12-22s, then 30-65s random gaps, max 6 per page view)
      var rnd = function(min, max) { return (min + Math.random() * (max - min)) * 1000; };
      var shown = 0, MAX_SHOWS = 6;
      var next = function(delay) {
        self.timer = setTimeout(function() {
          if (self.dismissed) return;
          if (!self.paused && !document.hidden) { self.show(); shown++; }
          if (shown < MAX_SHOWS) next(rnd(30, 65));
        }, delay);
      };
      next(rnd(12, 22));
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { SocialProof.init(); });
  } else {
    SocialProof.init();
  }
})();
